/*==============================================================================
  PEDIDO CONTRA ENTREGA — Soporte del popup (SupportLab Store)
  ----------------------------------------------------------------------------
  Autonomouso: no depende de jQuery ni del JS del tema. Se engancha al botón
  .t4s-pux-cod y controla el modal .t4s-cod.

  Responsabilidades:
    1. Abrir / cerrar el modal (botón, backdrop, ESC, botón de cierre).
    2. Leer la variante/precio ACTUALES del formulario de producto para que el
       popup nunca contradiga lo que el cliente ve en la ficha.
    3. Cantidad con total calculado.
    4. Validación de los datos del cliente.
    5. Construir el mensaje de WhatsApp y abrirlo en wa.me.

  Datos que necesita (data-* en el elemento raíz):
    data-cod-form     id del <form> de producto (para leer la variante)
    data-cod-phone    número de WhatsApp destino (solo dígitos, con país)
    data-cod-title    nombre del producto
    data-cod-url      URL del producto
    data-cod-intro    texto introductorio del mensaje
    data-cod-tpl      plantilla del mensaje con marcadores {campo}
    data-cod-shop     nombre de la tienda
==============================================================================*/

(function () {
  'use strict';

  var MODAL = '[data-t4s-cod-modal]';
  var OPENERS = '[data-t4s-cod-open]';
  var root = document.querySelector(MODAL);
  if (!root) return;

  // Mueve el modal a <body> para salir de cualquier stacking context del
  // contenedor: así el header y la barra sticky de "Añadir al carrito"
  // nunca quedan por encima del popup.
  if (root.parentNode !== document.body) {
    document.body.appendChild(root);
  }

  var cfg = {
    form: root.getAttribute('data-cod-product-form') || '',
    phone: (root.getAttribute('data-cod-phone') || '').replace(/[^0-9]/g, ''),
    title: root.getAttribute('data-cod-title') || '',
    url: root.getAttribute('data-cod-url') || '',
    intro: root.getAttribute('data-cod-intro') || '',
    tpl: root.getAttribute('data-cod-tpl') || '',
    shop: root.getAttribute('data-cod-shop') || ''
  };

  var panel = root.querySelector('[data-cod-panel]');
  var backdrop = root.querySelector('[data-cod-backdrop]');
  var closeBtn = root.querySelector('[data-cod-close]');
  var form = root.querySelector('[data-cod-form]');
  var nameIn = root.querySelector('[data-cod-name]');
  var phoneIn = root.querySelector('[data-cod-phone-input]');
  var addrIn = root.querySelector('[data-cod-addr]');
  var cityIn = root.querySelector('[data-cod-city]');
  var deptIn = root.querySelector('[data-cod-dept]');
  var notesIn = root.querySelector('[data-cod-notes]');
  var qtyInput = root.querySelector('[data-cod-qty]');
  var totalEl = root.querySelector('[data-cod-total]');
  var priceEl = root.querySelector('[data-cod-price]');
  var variantEl = root.querySelector('[data-cod-variant]');
  var submitBtn = root.querySelector('[data-cod-submit]');
  var resendBtn = root.querySelector('[data-cod-resend]');
  var doneBox = root.querySelector('[data-cod-done]');
  var formBox = root.querySelector('[data-cod-formbox]');
  var footBox = root.querySelector('[data-cod-foot]');

  var lastFocus = null;

  /*---------------------------------------------------------------------------
    Utilidades
  ---------------------------------------------------------------------------*/
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function money(cents) {
    // Formato de la tienda: $ con separador de miles (coma) y sin decimales.
    var n = Math.round(Number(cents) || 0) / 100;
    return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function digitsOnly(s) { return (s || '').replace(/[^0-9]/g, ''); }

  function showError(input, msg) {
    if (!input) return;
    input.classList.add('is-error');
    input.setAttribute('aria-invalid', 'true');
    var box = input.parentNode.querySelector('[data-cod-err]');
    if (box) {
      box.textContent = msg;
      box.classList.add('is-on');
    }
  }

  function clearError(input) {
    if (!input) return;
    input.classList.remove('is-error');
    input.removeAttribute('aria-invalid');
    var box = input.parentNode.querySelector('[data-cod-err]');
    if (box) {
      box.textContent = '';
      box.classList.remove('is-on');
    }
  }

  /*---------------------------------------------------------------------------
    Variante y precio actuales
    ---------------------------------------------------------------------------*/
  function productForm() {
    if (!cfg.form) return null;
    return document.getElementById(cfg.form);
  }

  // Variante seleccionada en el formulario de producto (select o input hidden)
  function currentVariantId() {
    var f = productForm();
    if (!f) return null;
    var sel = f.querySelector('select[name="id"]');
    if (sel && sel.value) return sel.value;
    var hid = f.querySelector('input[name="id"]');
    if (hid && hid.value) return hid.value;
    return null;
  }

  // Lee precio y nombre de variante desde el JSON que el tema ya imprime.
  // El script .pr_variants_json es HERMANO del <form>, dentro del contenedor
  // #t4s-callBackVariant, por eso buscamos en el padre del formulario.
  function readVariants() {
    var f = productForm();
    if (!f) return null;
    var scope = f.parentElement || f;
    var node = scope.querySelector('.pr_variants_json');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function readPriceFromDom() {
    // Respaldo: precio mostrado en la ficha.
    var f = productForm();
    if (!f) return null;
    var scope = f.parentElement || f;
    var box = scope.querySelector('.t4s-product-price');
    if (!box) return null;
    var ins = box.querySelector('ins');
    var txt = (ins ? ins.textContent : box.textContent) || '';
    txt = txt.replace(/\s+/g, ' ').trim();
    return txt || null;
  }

  function syncProduct() {
    var variants = readVariants();
    var vid = currentVariantId();
    var found = null;

    if (variants && vid) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(vid)) { found = variants[i]; break; }
      }
    }

    if (found) {
      if (priceEl) {
        var compare = found.compare_at_price && found.compare_at_price > found.price
          ? found.compare_at_price : null;
        priceEl.innerHTML = compare
          ? '<del>' + money(compare) + '</del> <ins>' + money(found.price) + '</ins>'
          : '<ins>' + money(found.price) + '</ins>';
      }
      if (variantEl) {
        var vt = (found.title || '').trim();
        variantEl.textContent = (vt && vt.toLowerCase() !== 'default title') ? vt : '';
      }
      return found.price;
    }

    // Sin JSON de variantes: usamos el precio base que Liquid inyectó en
    // data-cod-unit (en centavos). Es el caso de productos sin opciones.
    var baseCents = root.getAttribute('data-cod-unit');
    if (baseCents !== null && baseCents !== '') {
      var baseMoney = money(Number(baseCents));
      if (priceEl) priceEl.innerHTML = '<ins>' + baseMoney + '</ins>';
      if (variantEl) variantEl.textContent = '';
      return Number(baseCents);
    }

    // Respaldo visual por si el atributo tampoco está presente.
    if (priceEl) {
      var shown = readPriceFromDom();
      priceEl.innerHTML = shown ? '<ins>' + shown + '</ins>' : '';
    }
    if (variantEl) variantEl.textContent = '';
    return null;
  }

  /*---------------------------------------------------------------------------
    Cantidad y total
  ---------------------------------------------------------------------------*/
  function unitPrice() {
    // El precio en centavos se guarda en un atributo para poder multiplicar.
    var raw = root.getAttribute('data-cod-unit');
    if (raw !== null && raw !== '') return Number(raw);
    return null;
  }

  function currentQty() {
    var v = parseInt(qtyInput && qtyInput.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    if (v > 99) v = 99;
    return v;
  }

  function updateTotal() {
    if (!totalEl) return;
    var up = unitPrice();
    if (up === null) {
      var shown = priceEl ? (priceEl.textContent || '').trim() : '';
      totalEl.textContent = shown;
      return;
    }
    totalEl.textContent = money(up * currentQty());
  }

  function setQty(n) {
    if (!qtyInput) return;
    var v = n;
    if (isNaN(v) || v < 1) v = 1;
    if (v > 99) v = 99;
    qtyInput.value = v;
    updateTotal();
  }

  /*---------------------------------------------------------------------------
    Abrir / cerrar
  ---------------------------------------------------------------------------*/
  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;

    // Estado inicial
    formBox.style.display = '';
    doneBox.classList.remove('is-on');
    footBox.style.display = '';
    clearErrors();

    // Sincroniza producto
    var price = syncProduct();
    if (price !== null) {
      root.setAttribute('data-cod-unit', String(price));
    }
    setQty(currentQty());

    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('t4s-cod-open');

    // Foco al primer campo
    window.setTimeout(function () {
      var first = form && form.querySelector('input, textarea');
      if (first) first.focus();
    }, 260);
  }

  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('t4s-cod-open');
    qsa(OPENERS).forEach(function (b) { b.classList.remove('is-pressed'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function clearErrors() {
    qsa('[data-cod-err]', form).forEach(function (b) { b.classList.remove('is-on'); b.textContent = ''; });
    qsa('.is-error', form).forEach(function (i) { i.classList.remove('is-error'); i.removeAttribute('aria-invalid'); });
  }

  /*---------------------------------------------------------------------------
    Validación
  ---------------------------------------------------------------------------*/
  function validate() {
    var ok = true;
    var firstBad = null;

    function check(input, label, required) {
      if (!input) return;
      var val = (input.value || '').trim();
      if (required && !val) {
        showError(input, label + ' es obligatorio');
        ok = false; if (!firstBad) firstBad = input;
        return;
      }
      if (input === phoneIn && val) {
        var d = digitsOnly(val);
        if (d.length < 7) {
          showError(input, 'Ingresa un número de WhatsApp válido');
          ok = false; if (!firstBad) firstBad = input;
          return;
        }
      }
      clearError(input);
    }

    check(nameIn, 'El nombre', true);
    check(phoneIn, 'El teléfono', true);
    check(addrIn, 'La dirección', true);
    check(deptIn, 'El departamento', true);
    check(cityIn, 'La ciudad', true);
    check(notesIn, 'Las notas', false);

    if (!ok && firstBad) firstBad.focus();
    return ok;
  }

  /*---------------------------------------------------------------------------
    Mensaje de WhatsApp
  ---------------------------------------------------------------------------*/
  function buildMessage() {
    var qty = currentQty();
    var up = unitPrice();
    var unit = up !== null ? money(up) : (priceEl ? (priceEl.textContent || '').trim() : '');
    var total = up !== null ? money(up * qty) : unit;
    var variant = variantEl ? (variantEl.textContent || '').trim() : '';

    var data = {
      producto: cfg.title,
      variante: variant || '—',
      cantidad: qty,
      precio: unit,
      total: total,
      nombre: (nameIn.value || '').trim(),
      telefono: (phoneIn.value || '').trim(),
      direccion: (addrIn.value || '').trim(),
      departamento: (deptIn.value || '').trim(),
      ciudad: (cityIn.value || '').trim(),
      notas: (notesIn.value || '').trim() || '—',
      tienda: cfg.shop,
      enlace: cfg.url
    };

    // La plantilla vive en un elemento hijo [data-cod-tpl] para conservar
    // los saltos de línea. Si no existe, se usa el atributo de respaldo.
    var tplEl = root.querySelector('[data-cod-tpl]');
    var msg = tplEl ? tplEl.textContent : cfg.tpl;

    // Reemplaza {campo} con los valores. Sustituye en cascada para que los
    // valores ya sustituidos no se re-procesen.
    Object.keys(data).forEach(function (key) {
      msg = msg.split('{' + key + '}').join(data[key]);
    });

    // Limpia líneas vacías del bloque de notas
    msg = msg.replace(/\n{3,}/g, '\n\n').trim();

    var intro = cfg.intro ? cfg.intro + '\n' : '';
    return intro + msg;
  }

  function send() {
    if (!validate()) return;

    var msg = buildMessage();
    var link = 'https://wa.me/' + cfg.phone + '?text=' + encodeURIComponent(msg);
    if (resendBtn) resendBtn.href = link;

    // Abre en pestaña nueva; si el bloqueador lo impide, navega en la misma.
    var w = window.open(link, '_blank');
    if (!w) window.location.href = link;

    // Estado de éxito
    formBox.style.display = 'none';
    footBox.style.display = 'none';
    doneBox.classList.add('is-on');
  }

  /*---------------------------------------------------------------------------
    Eventos
  ---------------------------------------------------------------------------*/
  qsa(OPENERS).forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.classList.add('is-pressed');
      open();
    });
  });

  if (backdrop) backdrop.addEventListener('click', close);
  if (closeBtn) closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      if (root.classList.contains('is-open')) close();
    }
  });

  // Cantidad
  qsa('[data-cod-qty-btn]').forEach(function (b) {
    b.addEventListener('click', function () {
      var d = parseInt(b.getAttribute('data-cod-qty-btn'), 10) || 0;
      setQty(currentQty() + d);
    });
  });

  if (qtyInput) {
    qtyInput.addEventListener('change', function () { setQty(currentQty()); });
    qtyInput.addEventListener('input', function () { setQty(currentQty()); });
  }

  // Limpia el error en cuanto el usuario escribe
  qsa('input, textarea', form).forEach(function (i) {
    i.addEventListener('input', function () { clearError(i); });
  });

  // Envío
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); send(); });
  if (submitBtn) submitBtn.addEventListener('click', function (e) { e.preventDefault(); send(); });

  // Al cambiar de variante en la ficha, el popup se actualiza solo.
  document.addEventListener('variant:changed', function () {
    if (!root.classList.contains('is-open')) return;
    var price = syncProduct();
    if (price !== null) root.setAttribute('data-cod-unit', String(price));
    updateTotal();
  });

  // Si la variante cambia mientras el popup está abierto (jQuery del tema).
  if (window.jQuery) {
    window.jQuery(document).on('variant:changed', function () {
      if (!root.classList.contains('is-open')) return;
      var price = syncProduct();
      if (price !== null) root.setAttribute('data-cod-unit', String(price));
      updateTotal();
    });
  }

  // Expuesto para depurar
  window.t4sCod = { open: open, close: close, send: send, buildMessage: buildMessage };
})();
